export default __webpack_public_path__ + "cd11f4107d6c10c66346727c6151c92b.ttf";